// Constantes y utilerías de pantalla del módulo RMA.
// Gemelo de backend: erp_backend/Utils/rma/constantes.rma.js (los números de estado).

export const ESTADOS_RMA = {
  CANCELADO: 0,
  BORRADOR: 1,
  POR_AUTORIZAR: 2,
  AUTORIZADO: 3,
  RECHAZADO: 4,
  EN_RECEPCION: 5,
  POR_RESOLVER: 6,
  CERRADO: 7,
};

export const ETIQUETA_ESTADO_RMA = {
  0: { texto: "Cancelado", color: "red" },
  1: { texto: "Borrador", color: "default" },
  2: { texto: "Por autorizar", color: "gold" },
  3: { texto: "Autorizado", color: "blue" },
  4: { texto: "Rechazado", color: "volcano" },
  5: { texto: "En recepción", color: "cyan" },
  6: { texto: "Por resolver", color: "purple" },
  7: { texto: "Cerrado", color: "green" },
};

export const ESTADOS_EDITABLES = [ESTADOS_RMA.BORRADOR, ESTADOS_RMA.RECHAZADO];

// Valor del filtro de la lista: 0-7 un estado, 8 abiertos, 9 todos (igual que selectRMAs).
export const VALOR_ABIERTOS = 8;
export const VALOR_TODOS = 9;

// Pasos del expediente, para la barra de avance de la vista.
export const PASOS_RMA = ["Solicitud", "Autorización", "Recepción", "Inspección", "Resolución", "Cerrado"];

export const pasoDeEstado = (estado) => {
  switch (estado) {
    case ESTADOS_RMA.BORRADOR:
    case ESTADOS_RMA.RECHAZADO:
      return 0;
    case ESTADOS_RMA.POR_AUTORIZAR:
      return 1;
    case ESTADOS_RMA.AUTORIZADO:
    case ESTADOS_RMA.EN_RECEPCION:
      return 2;
    case ESTADOS_RMA.POR_RESOLVER:
      return 4;
    case ESTADOS_RMA.CERRADO:
      return 5;
    default:
      return 0;
  }
};

export const dinero = (n) => {
  const numero = Number(n) || 0;
  const [entero, decimales] = Math.abs(numero).toFixed(2).split(".");
  return `${numero < 0 ? "-" : ""}$${entero.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${decimales}`;
};

export const cantidadTexto = (n) => {
  const numero = Number(n) || 0;
  return Number.isInteger(numero) ? String(numero) : String(Math.round(numero * 10000) / 10000);
};

// Misma cuenta que el backend (calculos.rma.js): cantidad × precio neto × factor de
// impuestos × tipo de cambio. Solo es una vista previa; el monto que vale lo calcula el servidor.
export const importeConImpuestosMXN = (cantidad, renglon = {}) =>
  Math.round(
    (Number(cantidad) || 0) *
      (Number(renglon.precioUnitarioNeto) || 0) *
      (Number(renglon.factorImpuestos) || 1) *
      (Number(renglon.tipoDeCambio) || 1) *
      100
  ) / 100;

// Muestra el PDF en el iframe con location.replace: pdf.open() navega el iframe y mete una
// entrada al historial, y después el "Atrás" de la pantalla (history.goBack) solo regresa
// el iframe.
export const mostrarPdfEnIframe = (pdf, iframe, urlAnterior) =>
  new Promise((resolve) => {
    if (!pdf || !iframe?.contentWindow) return resolve(urlAnterior || null);
    pdf.getBlob((blob) => {
      const url = URL.createObjectURL(blob);
      try {
        iframe.contentWindow.location.replace(url);
      } catch (e) {
        iframe.src = url;
      }
      if (urlAnterior) setTimeout(() => URL.revokeObjectURL(urlAnterior), 1000);
      resolve(url);
    });
  });
